import * as d3 from "d3";
import React from "react";
import { currencyFormatter, Text } from "..";
import {
    AreaChartGraph,
    AreaChartXAxis,
    AreaChartYAxis,
    SalaryDistributionFill,
    SalaryVersusTimeLine,
    SalaryVersusTimeJobSalaryLine,
    SalaryDistributionLinePoints,
} from ".";

interface AreaChartProps {
    data: { percentile: number; salary: number }[];
    jobSalary?: { percentile: number; salary: number };
    mobile: boolean;
}

export const SalaryDistributionGraph = (props: AreaChartProps) => {
    const { data, jobSalary, mobile } = props;

    const d3Id = "salaryChart";

    const margin = mobile ? 12 : 50;
    const width = 600;
    const height = mobile ? 1.25 * width : 0.5 * width;

    const tickValues = [10, 25, 50, 75, 90];

    const yMax = d3.max(
        data,
        d =>
            Math.ceil(d.salary / 20000) * 20000
    );

    const xScale = d3
        .scaleLinear()
        .domain(d3.extent(data, d => d.percentile))
        .range([0, width - margin * 2]);

    const yScale = d3
        .scaleLinear()
        .domain([0, yMax] as number[])
        .range([height - margin * 2, 0]);

    return (
        <div id="container">
            {mobile && !!jobSalary ? (
                <div id="salary-legend-container">
                    <Text variant="caption">Your Job's Salary</Text>
                    <Text id="salary-legend">
                        {currencyFormatter.format(jobSalary.salary)}
                    </Text>
                </div>
            ) : null}
            <svg
                id={d3Id}
                viewBox={`0, 0, ${width + margin}, ${
                    mobile ? height + margin * 2 : height - margin
                }`}
            >
                <g transform={`translate(${margin}, ${margin / 2})`}>
                    <SalaryDistributionFill
                        xScale={xScale}
                        yScale={yScale}
                        data={data}
                        d3Id={d3Id}
                    />
                    <AreaChartXAxis
                        height={height}
                        margin={margin}
                        xScale={xScale}
                        tickValues={tickValues}
                        mobile={mobile}
                        d3Id={d3Id}
                    />
                    <AreaChartYAxis
                        mobile={mobile}
                        yScale={yScale}
                        d3Id={d3Id}
                    />
                    <SalaryVersusTimeLine
                        xScale={xScale}
                        yScale={yScale}
                        data={data}
                        mobile={mobile}
                        d3Id={d3Id}
                    />
                    {!!jobSalary ? (
                        <SalaryVersusTimeJobSalaryLine
                            jobSalary={jobSalary}
                            height={height}
                            margin={margin}
                            xScale={xScale}
                            mobile={mobile}
                            d3Id={d3Id}
                        />
                    ) : null}
                    <SalaryDistributionLinePoints
                        xScale={xScale}
                        yScale={yScale}
                        data={data}
                        mobile={mobile}
                        d3Id={d3Id}
                    />

                    <AreaChartGraph
                        height={height}
                        width={width}
                        margin={margin}
                        yScale={yScale}
                        xScale={xScale}
                        tickValues={tickValues}
                        mobile={mobile}
                        yMax={yMax}
                        d3Id={d3Id}
                    />
                </g>
            </svg>
        </div>
    );
};
